import { render, staticRenderFns } from "./trades.vue?vue&type=template&id=ef79b044&"
import script from "./trades.vue?vue&type=script&lang=ts&"
export * from "./trades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports